import { encode, decode } from "js-base64";

import { submitPhoneInfo } from "./services";

export async function getParams() {
  // 只取?param= 后面的base64编码
  let href = decodeURIComponent(window.location.href); // && window.location.href.replace(/%3D/g, '=')
  href = href.substr(href.indexOf("#/") + 2);
  const index = href.indexOf("=");
  const lastIndex = href.length;
  const queryString = href.substring(index + 1, lastIndex);
  console.log("paramsString", queryString);
  try {
    // const params = decodeBase64(queryString)
    // if (params) {
    //   console.log('params', params)
    //   return params
    // }
    const jsonString = decode(queryString);
    const params = JSON.parse(jsonString);
    console.log("params", params);
    return params;
  } catch (err) {
    console.log("err", err);
    return "";
  }
}

import MobileDetect from "mobile-detect";
function getUserAgent() {
  //判断数组中是否包含某字符串
  Array.prototype.contains = function(needle) {
    for (i in this) {
      console.log("this[i]", this[i]);
      if (typeof this[i] == "string" && this[i].indexOf(needle) > 0) return i;
    }
    return -1;
  };

  const deviceType = navigator.userAgent; //获取userAgent信息
  const md = new MobileDetect(deviceType); //初始化mobile-detect
  var os = md.os(); //获取系统
  var version = ""; //系统的版本号
  var model = ""; //设备型号
  if (os == "iOS") {
    //ios系统的处理
    version = md.version("iPhone");
    os = md.os();
    model = md.mobile();
  } else if (os == "AndroidOS") {
    //Android系统的处理
    os = md.os();
    version = md.version("Android");
    var sss = deviceType.split(";");
    var i = sss.contains("Build/");
    if (i > -1) {
      model = sss[i].substring(0, sss[i].indexOf("Build/"));
    }
  }
  //组装信息
  var info = {
    osType: os, //系统类型
    osVersionCode: version, //系统版本号
    model: model, //设备型号
    extendAttr: deviceType // userAgent信息
  };
  console.log("userAgent信息", info);
  return info;
}

export async function postUserDeviceInfo(mobileNo) {
  try {
    const userAgent = getUserAgent();
    const params = {
      ...userAgent,
      phone: mobileNo
    };
    const response = await submitPhoneInfo(params);
    if (response) {
      console.log("设备信息上报成功！");
    }
  } catch (err) {
    console.log("err", err);
  }
}

// export async function decodeBase64 (params) {
//   try {
//     const response = await decode64({text: params})
//     if (response && response.data) {
//       console.log('encode64', response.data)
//       return response.data
//     }
//   } catch (err) {
//     console.log('err', err)
//     return {}
//   }
// }

// export async function encodeBase64 (params) {
//   try {
//     const response = await encode64(params)
//     if (response && response.data) {
//       console.log('encode64', response.data)
//       return response.data
//     }
//   } catch (err) {
//     console.log('err', err)
//     return ''
//   }
// }



// WEBPACK FOOTER //
// ./src/utils.js